import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  Breadcrumb as BreadcrumbRoot,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from './ui/breadcrumb';

const Breadcrumb = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const searchParam = searchParams.entries().next().value?.[1];
  const pathnames = location.pathname.split('/').filter(x => x);

  if (searchParam && isNaN(Number(searchParam))) pathnames.push(searchParam);

  return (
    <BreadcrumbRoot aria-label="breadcrumb">
      <BreadcrumbList className="text-[#b8b8b8]">
        <BreadcrumbItem>
          <BreadcrumbLink
            render={<Link to="/" />}
            className="capitalize text-sm hover:text-foreground"
          >
            {t('router.home')}
          </BreadcrumbLink>
        </BreadcrumbItem>
        {pathnames.map((value, index) => {
          const to = pathnames.slice(0, index + 1).join('/');
          const filteredTo = to.includes('product') ? 'products' : to;
          const isLast = index === pathnames.length - 1;
          const label = i18n.exists(`router.${value}`) ? t(`router.${value}`) : value;

          return (
            <span key={to} className="flex items-center gap-1.5">
              <BreadcrumbSeparator>/</BreadcrumbSeparator>
              <BreadcrumbItem>
                {isLast ? (
                  <BreadcrumbPage className="capitalize text-sm text-gray-500">
                    {label}
                  </BreadcrumbPage>
                ) : (
                  <BreadcrumbLink
                    render={<Link to={`/${filteredTo}`} />}
                    className="capitalize text-sm hover:text-foreground"
                  >
                    {label}
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
            </span>
          );
        })}
      </BreadcrumbList>
    </BreadcrumbRoot>
  );
};

export default Breadcrumb;
